import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Survey } from '@app/interface/survey';
import { first, firstValueFrom } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  private _isFromMatrix = true;


  URL = `${environment.mkgoURL}/api/v1/survey-model`;

  constructor(
    private _http: HttpClient,
    private _dataService: DataService
  ) { }

  public async create(survey: Survey): Promise<any> {
    const options = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.post(this.URL, survey, options).pipe(first()).toPromise();
    return resp;
  }

  /** @todo test */
  public async get(id: string): Promise<Survey> {
    const url = `${this.URL}/${id}`;
    const options = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.get(url, options).pipe(first()).toPromise();
    return resp as Survey;

  }

  public async getAll(): Promise<Survey[]> {
    const options = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
    const resp: { surveyModels: Survey[] } = await this._http.get(this.URL, options).pipe(first()).toPromise() as any;
    return resp.surveyModels;
  }

  public async update(survey: Survey): Promise<any> {
    const url = `${this.URL}/${survey._id}`;
    const options = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.put(url, survey, options).pipe(first()).toPromise();
    return resp;
  }

  public async delete(id: string): Promise<any> {
    const url = `${this.URL}/${id}`;
    const options = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.delete(url, options).pipe(first()).toPromise();
    return resp;
  }


}

